import { baseFetch } from "../../helpers/apiClient";

/**
 * The goals a member chose at onboarding, and the ability to change them.
 *
 * `POST /v2/onboarding/complete` refuses a second call and points at "the
 * relevant profile edit endpoints" — these are those. The read is the exact
 * inverse of what completion stored, so what comes back from `fetchGoals` is
 * the same shape `saveGoals` accepts, and the editor can hand one straight to
 * the other.
 *
 * `baseFetch` rather than the onboarding client: this runs under the ordinary
 * app session, not the restricted onboarding-scoped one.
 */

const unwrap = (response) => response?.data ?? response;

/** `GET /v2/me/goals` — the current selection, prefilled into the editor. */
export const fetchGoals = async () => {
  const response = await baseFetch({ url: "/v2/me/goals" });
  const data = unwrap(response);
  return { goals: data?.goals ?? [], goalData: data?.goalData ?? {} };
};

/**
 * `PUT /v2/me/goals` — replace the selection.
 *
 * The whole selection, never a patch: goals share answers that have to agree
 * with one another, so a partial update could not be checked against the rules
 * onboarding uses.
 *
 * Removing "provide mentorship" revokes the mentor role and its capability, so
 * the caller should have confirmed that with the member first.
 */
export const saveGoals = async ({ goals, goalData }) => {
  const response = await baseFetch({
    url: "/v2/me/goals",
    method: "PUT",
    body: { goals, goalData },
  });
  return unwrap(response);
};
